import React from 'react';
import Box from '../Box';
import { keyframes } from '@emotion/react';

export interface TimeIndicatorProps {
  time: number;
  size?: number;
}

const strokeDasharrayKeyframes = keyframes({
  '0%': {
    strokeDasharray: '0 100',
  },
});

const TimeIndicator: React.FC<TimeIndicatorProps> = React.memo(
  function TimeIndicator({ time, size = 32 }) {
    const center = size / 2;
    const strokeWidth = 2;
    const radius = center - strokeWidth;
    const circumference = 2 * Math.PI * radius;
    const percentage = Math.min((time * circumference) / 60, circumference);
    const textY = center + 5;
    const sharedProps = {
      cx: center,
      cy: center,
      r: radius,
    };

    return (
      <Box width={size + 'px'} height={size + 'px'}>
        <svg
          aria-describedby="timeindicator-description"
          viewBox={`0 0 ${size} ${size}`}
        >
          <desc id="timeindicator-description">{time} minutes</desc>
          <circle
            {...sharedProps}
            css={{ fill: 'none', strokeWidth: 4, stroke: '#FFFFFF' }}
          />
          <circle
            {...sharedProps}
            css={{
              fill: 'none',
              strokeWidth: 4,
              strokeLinecap: 'round',
              animation: `${strokeDasharrayKeyframes} 1s ease-out forwards`,
              stroke: '#333D47',
              transform: 'rotate(-90deg)',
              transformOrigin: 'center',
            }}
            strokeDasharray={`${percentage}, ${circumference}`}
          />
          <text
            css={{
              fontSize: '12px',
              width: '2.25rem',
              height: '2.25rem',
            }}
            x={center}
            y={textY}
            dominantBaseline="auto"
            textAnchor="middle"
          >
            {time}
          </text>
        </svg>
      </Box>
    );
  }
);

export default TimeIndicator;
